import { useEffect } from 'react';
import { syncSideloadedExtensionsToMembers } from '../../../features/extensions/sideloading/syncSideloadedExtensionsToMembers';
import { getMemberIds } from '../../../features/realtime/realtime.selectors';
import { useAppSelector, useAppDispatch } from '../../useReduxToolkit';
import { isProduction } from '../../../shared/isProduction';

/**
 * Provider hook: when room members change, sends ExtensionSideloadSync
 * to all current members so they can load the same sideloaded extensions.
 * Sideload entry points also dispatch {@link syncSideloadedExtensionsToMembers}.
 * No-op in production.
 */
export function useSideloadSync(): void {
  const dispatch = useAppDispatch();
  const memberIds = useAppSelector(getMemberIds);
  const joinedMembersIds = useAppSelector(
    (state) => state.realtime.joinedMembersIds,
  );

  useEffect(() => {
    if (isProduction()) {
      return;
    }
    void dispatch(syncSideloadedExtensionsToMembers());
  }, [dispatch, memberIds, joinedMembersIds]);
}
